export type ResourceCalendarViewTranslation = {
  alertCalendarsDisabled: string;
  calendarGrouping: {
    day: string;
    label: string;
    month: string;
    week: string;
  };
  clearFilters: string;
  dayAriaLabel: string;
  empty: string;
  emptyDay: string;
  emptyFiltered: string;
  emptyWeek: string;
  filterElements: string;
  filterStatus: string;
  gantt: {
    anchor: string;
  };
  legend: {
    windowConfirmed: string;
    windowTentative: string;
  };
  loadError: string;
  monthAriaLabel: string;
  nextDay: string;
  nextMonth: string;
  nextWeek: string;
  prevDay: string;
  prevMonth: string;
  prevWeek: string;
  slotCreate: {
    menu: string;
    process: string;
    recurringReservation: string;
  };
  status: {
    confirmed: string;
    free: string;
    tentative: string;
  };
  today: string;
  typeLabel: string;
  viewMode: {
    calendar: string;
    gantt: string;
    label: string;
  };
  weekAriaLabel: string;
};

export const resourceCalendarTranslation: ResourceCalendarViewTranslation = {
  alertCalendarsDisabled: 'Kalendarze są wyłączone dla wybranego typu słownika.',
  calendarGrouping: {
    day: 'Dzień',
    label: 'Zakres kalendarza',
    month: 'Miesiąc',
    week: 'Tydzień',
  },
  clearFilters: 'Wyczyść filtry',
  dayAriaLabel: 'Wybrany dzień',
  empty: 'Brak zajętych elementów w wybranym miesiącu.',
  emptyDay: 'Brak zajętych elementów w wybranym dniu.',
  emptyFiltered: 'Brak wyników dla wybranych filtrów.',
  emptyWeek: 'Brak zajętych elementów w wybranym tygodniu.',
  filterElements: 'Elementy',
  filterStatus: 'Status',
  gantt: {
    anchor: 'Początek osi',
  },
  legend: {
    windowConfirmed: 'Montaż lub demontaż (rezerwacja potwierdzona)',
    windowTentative: 'Montaż lub demontaż (rezerwacja wstępna)',
  },
  loadError: 'Wystąpił błąd podczas ładowania dostępności kalendarza.',
  monthAriaLabel: 'Wybrany miesiąc',
  nextDay: 'Następny dzień',
  nextMonth: 'Następny miesiąc',
  nextWeek: 'Następny tydzień',
  prevDay: 'Poprzedni dzień',
  prevMonth: 'Poprzedni miesiąc',
  prevWeek: 'Poprzedni tydzień',
  slotCreate: {
    menu: 'Co utworzyć w wybranym terminie?',
    process: 'Proces',
    recurringReservation: 'Rezerwacja stała',
  },
  status: {
    confirmed: 'Rezerwacja potwierdzona',
    free: 'Wolny dzień (pusta komórka)',
    tentative: 'Rezerwacja wstępna',
  },
  today: 'Dzisiaj',
  typeLabel: 'Typ słownika',
  viewMode: {
    calendar: 'Kalendarz',
    gantt: 'Gantt',
    label: 'Tryb widoku',
  },
  weekAriaLabel: 'Wybrany tydzień',
};
